import { useMutation } from '@tanstack/react-query';
import { MutationKey } from '@shared/config';
import { authApi } from '../../authApi';
import type { SurferRegistrationPreflightRequest } from '../../types';

export const useSurferRegisterVerification = () =>
  useMutation({
    mutationKey: [MutationKey.AUTH_SURFER_REGISTER_VERIFICATION],
    mutationFn: (payload: SurferRegistrationPreflightRequest) =>
      authApi.prepareSurferRegistration(payload),
  });
